// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2020-03-30 02:45:36 +0200 (Mon, 30 Mar 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 109159 $
//  Purpose   : migrate persisted parts of redux store
// =============================================================================
// ---Third-party imports

import {createMigrate} from 'redux-persist'

// ---Framework imports
import {keys, sorted} from 'ldash'
import log from 'uix/logging'

// ---Globals
let migration = cfg => ({
  migrate: createMigrate(cfg),
  // auto-increase version on added keys
  version: sorted(keys(cfg).map(e => parseInt(e))).slice(-1)[0],
})

export let data = migration({
  0: data => {
    // added created
    log.warn('migrated root.data to v0')
    return {
      ...data,
      job: {active: [], seen: [], created: []},
    }
  },
  //~ 1: (data) => {
  //~ return {...}
  //~ }
})

export let meta = migration({
  0: data => {
    // added created
    log.warn('migrated root.meta to v0')
    return {
      ...data,
      contextHelp: {on: false, navigation: {}},
    }
  },
})
